exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nbody {\n    width: 100%;\n    min-width: 100% !important;\n}\n\n.container {\n    width: 100%;\n    min-width: 100% !important;\n}\n\n.btn-primary {\n\tbackground-color: #394456;\n\tborder: none;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/css-loader?{"sourceMap":false,"importLoaders":1}!/srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/postcss-loader?{"ident":"postcss"}!/srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 1